import React, { useContext, useEffect, useState } from "react";

import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import {
  Box,
  FormButtonStyled,
  HeadingStyled,
} from "../../../../components/styled/Elements";
import { LeadFormWrapper } from "./style";
import FormData from "form-data";
import "react-toastify/dist/ReactToastify.css";
import CustomRadioButton from "../../../../components/common/radioButtons/CustomRadio";
import ValidatedInput from "../../../../components/common/inputFields/ValidatedInput";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import VisitorApi from "../../../../services/api/visitorApi";
import FloatingPhoneInput from "../../../../components/common/inputFields/FloatingPhoneInput";
import { AuthContext } from "../../../../context/authContext";
import { requireAuthNavigate } from "../../../../utils";
import InquiryLoginRequired from "./InquiryLoginRequired";

const LeadFormMobile = ({ user }) => {
  const {
    t,
    i18n: { language, dir },
  } = useTranslation();
  const isRTL = dir() === "rtl";
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);
  const { username } = useParams();

  const validationSchema = Yup.object().shape({
    inquiry_type: Yup.string().required("validate_inquiry_type"),
    property_category: Yup.string().required("validate_property_category"),
    full_name: Yup.string().required("validate_full_name"),
    phone_number: Yup.string().required("Phone_requried"),
  });

  const [onChangeData, setOnChangeData] = useState({
    user_id: user?.id,
    inquiry_type: "",
    property_category: "",
    full_name: "",
    phone_number: "",
  });
  const [formValidationErrors, setFormValidationErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showBox, setShowBox] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [propertyType, setPropertyType] = useState("");
  const [bedroomActive, setBedroomActive] = useState(false);
  const [propertyState, setPropertyState] = useState({
    Apartment: false,
    Villa: false,
    Palace: false,
    Land: false,
    Building: false,
    Chalet: false,
    Farm: false,
    Duplex: false,
    Floor: false,
    "Rest House": false,
    terms_conditions: false,
  });
  const [propertyTypes, setPropertyTypes] = useState(null);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const radioOptions = [
    { id: "1", label: t("Buy") },
    { id: "2", label: t("Rent") },
    { id: "3", label: t("Sale") },
  ];
  const categoryOptions = [
    { id: "1", label: t("Residential") },
    { id: "2", label: t("Commercial") },
  ];

  const handleSelectorChange = (e, id) => {
    let propertyName;
    if (id === "1") {
      propertyName = t("Residential");
      setOnChangeData((prevData) => ({ ...prevData, property_category: id }));
    } else {
      propertyName = t("Commercial");
      setOnChangeData((prevData) => ({ ...prevData, property_category: id }));
    }
    const newPropertyType = propertyName;

    // Reset propertyState when switching property type
    const resetPropertyState = Object.keys(propertyState).reduce(
      (acc, property) => {
        acc[property] = false;
        return acc;
      },
      {}
    );
    setPropertyState(resetPropertyState);

    // Reset bedroomState when switching property type
    const resetBedroomState = Object.keys(bedroomState).reduce(
      (acc, bedroom) => {
        acc[bedroom] = false;
        return acc;
      },
      {}
    );
    setBedroomState(resetBedroomState);

    setPropertyType(newPropertyType);
    setBedroomActive(propertyState[newPropertyType]); // Set bedroomActive based on the new property type
    setShowBox(false);
  };

  const [bedroomState, setBedroomState] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    "9+": false,
    Studio: false,
  });

  const handleAddDistricts = () => setShowModal(true);
  const [cityData, setCityData] = useState([]);
  const [selectedCity, setSelectedCity] = useState();
  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [cityNameSelect, setCityNameSelect] = useState("");
  const [districts, setDistricts] = useState([]);
  const [selectedDistrictNames, setSelectedDistrictNames] = useState([]);

  const getCityData = async () => {
    try {
      const body = await VisitorApi.getCitiesList();
      if (body?.data) {
        // console.log('city data', response.data.data[0].name_ar);
        setCityData(
          body?.data?.map((city) => ({
            ...city,
            value: city?.city_id,
            label: language === "ar" ? city?.name_ar : city?.name_en,
          }))
        ); // Update cityData state with fetched data
        // console.log("State____", response.data.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getCityData();
  }, [isRTL]);
  useEffect(() => {
    const cityName = cityData.find(
      (city) => city.city_id == selectedCity
    )?.name_en;
    const cityNameInRTL = cityData.find(
      (city) => city.city_id == selectedCity
    )?.name_ar;
    const selectedCityName = isRTL ? cityNameInRTL : cityName;

    setCityNameSelect(selectedCityName || "");
  }, [selectedCity, cityData, isRTL, language]);

  const validateFormData = async () => {
    try {
      await validationSchema.validate(onChangeData, { abortEarly: false });
      setFormValidationErrors({});
      return true;
    } catch (error) {
      const errors = {};
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
      setFormValidationErrors(errors);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !requireAuthNavigate(
        navigate,
        isAuthenticated,
        `${location.pathname}${location.search}`
      )
    ) {
      return;
    }
    const formData = new FormData();
    const isValidData = await validateFormData();
    if (!isValidData) return;

    Object.entries(onChangeData).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((val) => formData.append(`${key}[]`, val));
      } else {
        if (value !== undefined && value !== null && value !== "") {
          formData.append(key, value);
        }
      }
    });

    try {
      setIsLoadingSubmit(true);
      const body = await VisitorApi.createInquiry(formData);
      if (body?.code === 200) {
        localStorage.setItem(
          "inquiry_form_data",
          JSON.stringify(body?.data)
        );
        setOnChangeData({
          user_id: "",
          inquiry_type: "",
          property_category: "",
          full_name: "",
          phone_number: "",
        });
        navigate(`/profile/${username}/inquiry-form`);
        // toast.success(t("inquiry_successful"));
      }
    } catch (error) {
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const onChangeHandler = (e) => {
    const { name, value } = e.target;

    if (value) {
      setOnChangeData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const requiredFields = [
    "inquiry_type",
    "property_category",
    "full_name",
    "phone_number",
  ];

  const isAllFilled = requiredFields.every(
    (key) => onChangeData[key] && String(onChangeData[key]).trim() !== ""
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOnChangeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  if (!isAuthenticated) {
    return <InquiryLoginRequired />;
  }

  return (
    <LeadFormWrapper>
      <form className="py-3" onSubmit={handleSubmit}>
        <Row>
          <Col lg={12} md={12}>
            <Box className="field-box pb-0 border-bottom-line">
              <HeadingStyled className="label-heading">
                {t("looking_property")}
              </HeadingStyled>
              <Box className="active-radio-container d-flex flex-md-nowrap flex-wrap gap-2">
                {radioOptions.map((option) => (
                  <Box key={option.id}>
                    <CustomRadioButton
                      name="inquiry_type"
                      label={t(option.label)}
                      checked={onChangeData?.inquiry_type == option?.id}
                      value={option.id}
                      onChange={onChangeHandler}
                    />
                  </Box>
                ))}
              </Box>
              {formValidationErrors.inquiry_type && (
                <div className="error-message">
                  {t(formValidationErrors.inquiry_type)}
                </div>
              )}
            </Box>
          </Col>
          <Col lg={12} md={12}>
            <Box className="field-box pb-0 border-bottom-line">
              <Box className="property-categories my-2">
                <HeadingStyled className="label-heading mb-2">
                  {t("Property_category")}{" "}
                </HeadingStyled>
                <Box className="active-radio-container d-flex flex-md-nowrap flex-wrap gap-2">
                  {categoryOptions.map((option) => (
                    <Box key={option.id}>
                      <CustomRadioButton
                        name="property_category"
                        label={t(option.label)}
                        value={option.id}
                        checked={option.label === propertyType}
                        onChange={(e) => handleSelectorChange(e, option.id)}
                      />
                    </Box>
                  ))}
                </Box>
                {formValidationErrors.property_category && (
                  <div className="error-message mt-2">
                    {t(formValidationErrors.property_category)}
                  </div>
                )}
              </Box>
            </Box>
          </Col>

          <Col lg={6} md={12}>
            <Box className="field-box pb-0">
              <HeadingStyled className="label-heading">
                {t("Full_Name")}{" "}
              </HeadingStyled>
              <ValidatedInput
                name="full_name"
                // label={"Full_Name"}
                type="input"
                fieldType="text"
                placeholder={t("Full_Name_place")}
                className={"w-100 mb-0 combined flex-wrap p-0"}
                onChange={handleInputChange}
              />
            </Box>
            {formValidationErrors.full_name && (
              <div className="error-message">
                {t(formValidationErrors.full_name)}
              </div>
            )}
          </Col>
          <Col lg={6} md={12}>
            <Box className="field-box pb-0">
              <HeadingStyled className="label-heading">
                {" "}
                {t("Phone_Number")}{" "}
              </HeadingStyled>
              <FloatingPhoneInput
                name="phone_number"
                // label={"Full_Name"}
                placeholder={t("Phone_Number_place")}
                className={"w-100 mb-2 mt-2 combined flex-wrap p-0"}
                value={onChangeData?.phone_number || ""}
                onChange={handleInputChange}
              />
            </Box>
            {formValidationErrors.phone_number && (
              <div className="error-message">
                {t(formValidationErrors.phone_number)}
              </div>
            )}
          </Col>
          <Box className="mt-3 w-100">
            <FormButtonStyled
              style={{ width: "100%" }}
              className="w-100"
              disabled={!isAllFilled || isLoadingSubmit}
              isLoading={isLoadingSubmit}
              label={t("click_here_to_complete_form")}
              type="submit"
            />
            {/* <p className='loading-btn'><span className='spinner'></span></p> */}
          </Box>
        </Row>
      </form>
    </LeadFormWrapper>
  );
};

export default LeadFormMobile;
